import { render } from "./NotificationsList.vue?vue&type=template&id=d961ea38&scoped=true&ts=true"
import script from "./NotificationsList.vue?vue&type=script&lang=ts"
export * from "./NotificationsList.vue?vue&type=script&lang=ts"

import "./NotificationsList.vue?vue&type=style&index=0&id=d961ea38&scoped=true&lang=scss"

import exportComponent from "/opt/apps/parcel4you-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d961ea38"]])

export default __exports__